module.exports = __webpack_public_path__ + "img/1556027598.d0808955.jpg";